const extractUserData = (detail: any) => {
    const userData: {
        first_name?: string
        last_name?: string
        email?: string
        country?: string
        city?: string
        postal_code?: string
    } = {}

    // Extract email (most common field)
    if (detail.email) {
        userData.email = detail.email
    } else if (detail.$email) {
        userData.email = detail.$email
    } else if (detail.metaData?.$email) {
        userData.email = detail.metaData.$email
    }

    // Extract first name
    if (detail.firstName) {
        userData.first_name = detail.firstName
    } else if (detail.$first_name) {
        userData.first_name = detail.$first_name
    } else if (detail.first_name) {
        userData.first_name = detail.first_name
    } else if (detail.metaData?.$first_name) {
        userData.first_name = detail.metaData.$first_name
    }

    // Extract last name
    if (detail.lastName) {
        userData.last_name = detail.lastName
    } else if (detail.$last_name) {
        userData.last_name = detail.$last_name
    } else if (detail.last_name) {
        userData.last_name = detail.last_name
    } else if (detail.metaData?.$last_name) {
        userData.last_name = detail.metaData.$last_name
    }

    // Extract country
    if (detail.country) {
        userData.country = detail.country
    } else if (detail.$country) {
        userData.country = detail.$country
    } else if (detail.metaData?.$country) {
        userData.country = detail.metaData.$country
    }

    // Extract city
    if (detail.city) {
        userData.city = detail.city
    } else if (detail.$city) {
        userData.city = detail.$city
    } else if (detail.metaData?.$city) {
        userData.city = detail.metaData.$city
    }

    // Extract postal code
    if (detail.postalCode) {
        userData.postal_code = detail.postalCode
    } else if (detail.$postal_code) {
        userData.postal_code = detail.$postal_code
    } else if (detail.zipCode) {
        userData.postal_code = detail.zipCode
    } else if (detail.$zip_code) {
        userData.postal_code = detail.$zip_code
    } else if (detail.metaData?.$postal_code) {
        userData.postal_code = detail.metaData.$postal_code
    } else if (detail.metaData?.$zip_code) {
        userData.postal_code = detail.metaData.$zip_code
    }

    return userData
}

export { extractUserData }
